"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _throttleDebounce = require("throttle-debounce");
var _types = require("../../../../types");
var _types2 = require("../../../../actions/filters/types");
var _selectors = require("../../../../selectors");
var _useActions = require("../useActions");
var _useAnalytics = require("../useAnalytics");
var _analytics = require("../../../../analytics");
var _placeholders = require("./constants/placeholders");
var _useHandleSuggestItemClick = require("./useHandleSuggestItemClick");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let timerIdForAddressInputLaterSomeSeconds;
const timeoutAddressInputLater = 5000;
const useAddressProps = _ref => {
  let {
    isDesktop,
    targetPage,
    isMyHome
  } = _ref;
  const {
    address,
    errorTooltip,
    addressGeoSuggest,
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setAddress,
    getFlatAreasSuggest,
    getAddressGeoSuggest
  } = (0, _useActions.useActions)();

  /** Функции аналитики отличаеются для моего дома */
  const submitAnalyticsClick = isMyHome ? _analytics.trackMyHomeAddressInputClick : _analytics.trackAddressInputClick;
  const submitAnalyticsInput = isMyHome ? _analytics.trackMyHomeAddressInputLaterSomeSeconds : _analytics.trackAddressInputLaterSomeSeconds;
  const {
    trackAddressChangeThrottled
  } = (0, _useAnalytics.useAnalytics)(isMyHome);

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === _types2.ECurrentErrorField.address ? errorTooltip.errorText : '';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getGeoSuggestDebounced = React.useCallback((0, _throttleDebounce.debounce)(200, getAddressGeoSuggest), []);

  /** Обработчик ввода адреса */
  const onValueChange = React.useCallback(value => {
    clearTimeout(timerIdForAddressInputLaterSomeSeconds);
    trackAddressChangeThrottled(value, estimationTarget);
    setAddress({
      address: value
    });
    getGeoSuggestDebounced(value, targetPage);
    if (value) {
      timerIdForAddressInputLaterSomeSeconds = window.setTimeout(() => submitAnalyticsInput(value, estimationTarget), timeoutAddressInputLater);
    }
  }, [getGeoSuggestDebounced, setAddress, trackAddressChangeThrottled, estimationTarget, targetPage]);

  /** Обработчик клика по итему в геосаджесте (список предложенных адресов) */
  const handleItemClick = (0, _useHandleSuggestItemClick.useHandleSuggestItemClick)(errorMessage, timerIdForAddressInputLaterSomeSeconds);

  /** Обработчик клика по инпуту */
  const onInputTagClick = React.useCallback(e => {
    if (e.target.tagName === 'INPUT') {
      submitAnalyticsClick(estimationTarget);
    }
  }, [estimationTarget]);

  /** В момент 1й загрузки делается запрос за саджестом, если в сторе имеется адрес Квартиры */
  React.useEffect(() => {
    if (address && estimationTarget === _types.EEstimationTargets.flat) {
      getFlatAreasSuggest(address);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    value: address,
    errorMessage,
    addressGeoSuggest,
    onInputTagClick,
    onValueChange,
    onItemClick: handleItemClick,
    placeholder: _placeholders.placeholders[isDesktop ? 'desktop' : 'mobile'][estimationTarget]
  };
};
exports.useAddressProps = useAddressProps;